"use client";

import { c as _c } from "react/compiler-runtime";
import DropsListItemDeleteDropModal from "@/components/drops/view/item/options/delete/DropsListItemDeleteDropModal";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import CommonAnimationWrapper from "@/components/utils/animation/CommonAnimationWrapper";
import CommonDropdownItemsDefaultWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsDefaultWrapper";
import { useAuth } from "@/components/auth/Auth";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useCanShowDropCurationsAction } from "@/hooks/drops/useCanShowDropCurationsAction";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import { EllipsisHorizontalIcon } from "@heroicons/react/24/outline";
import { useRef, useState } from "react";
import { Tooltip } from "react-tooltip";
import WaveDropActionsCopyLink from "./WaveDropActionsCopyLink";
import WaveDropCurationsActionIcon from "./WaveDropCurationsActionIcon";
import WaveDropCurationsDialog from "./WaveDropCurationsDialog";
import WaveDropActionsMarkUnread from "./WaveDropActionsMarkUnread";
import WaveDropActionsOpen from "./WaveDropActionsOpen";
import WaveDropActionsOptions from "./WaveDropActionsOptions";
import WaveDropActionsRestoreLinkPreviews from "./WaveDropActionsRestoreLinkPreviews";
import WaveDropActionsSetPinnedDrop from "./WaveDropActionsSetPinnedDrop";
interface WaveDropActionsMoreProps {
  readonly drop: ExtendedDrop;
  readonly onOpenChange?: (isOpen: boolean) => void;
}
export default function WaveDropActionsMore(t0) {
  const $ = _c(71);
  const {
    drop,
    onOpenChange
  } = t0;
  const {
    connectedProfile
  } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isCurationsDialogOpen, setIsCurationsDialogOpen] = useState(false);
  const buttonRef = useRef(null);
  const {
    canDelete,
    canSetPinnedDrop
  } = useDropInteractionRules(drop);
  const t1 = drop.id;
  let t2;
  if ($[0] !== drop.id) {
    t2 = drop.id.startsWith("temp-");
    $[0] = drop.id;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = drop.wave.authenticated_user_admin === true;
  const t4 = (isOpen || isCurationsDialogOpen) && Boolean(connectedProfile?.handle);
  let t5;
  if ($[2] !== drop.id || $[3] !== t2 || $[4] !== t3 || $[5] !== t4) {
    t5 = {
      dropId: t1,
      isTemporaryDrop: t2,
      isWaveAdmin: t3,
      enabled: t4
    };
    $[2] = drop.id;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const showCurationsAction = useCanShowDropCurationsAction(t5);
  let t6;
  if ($[7] !== onOpenChange) {
    t6 = newIsOpen => {
      setIsOpen(newIsOpen);
      onOpenChange?.(newIsOpen);
    };
    $[7] = onOpenChange;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const handleOpenChange = t6;
  let t7;
  if ($[9] !== handleOpenChange) {
    t7 = () => handleOpenChange(false);
    $[9] = handleOpenChange;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const closeDropdown = t7;
  let t8;
  if ($[11] !== handleOpenChange) {
    t8 = () => {
      handleOpenChange(false);
      setIsDeleteModalOpen(true);
    };
    $[11] = handleOpenChange;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const handleDeleteClick = t8;
  let t9;
  if ($[13] !== handleOpenChange || $[14] !== isOpen) {
    t9 = () => handleOpenChange(!isOpen);
    $[13] = handleOpenChange;
    $[14] = isOpen;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = `more-actions-${drop.id}`;
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <EllipsisHorizontalIcon className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-transition tw-duration-300 tw-ease-out" />;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== isOpen || $[18] !== t10 || $[19] !== t9) {
    t12 = <button ref={buttonRef} className="tw-flex tw-h-7 tw-w-7 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-transparent tw-text-iron-400 tw-transition-all tw-duration-200 tw-ease-out desktop-hover:hover:tw-bg-iron-800 desktop-hover:hover:tw-text-iron-200" onClick={t9} aria-label="More actions" aria-haspopup="true" aria-expanded={isOpen} data-tooltip-id={t10}>{t11}</button>;
    $[17] = isOpen;
    $[18] = t10;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== drop.id || $[22] !== isOpen) {
    t13 = !isOpen && <Tooltip id={`more-actions-${drop.id}`} place="top" offset={8} opacity={1} style={{
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 99999,
      pointerEvents: "none"
    }}><span className="tw-text-xs">More</span></Tooltip>;
    $[21] = drop.id;
    $[22] = isOpen;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  let t15;
  if ($[24] !== closeDropdown || $[25] !== drop) {
    t14 = <WaveDropActionsMarkUnread drop={drop} isDropdownItem={true} onMarkUnread={closeDropdown} />;
    t15 = <WaveDropActionsCopyLink drop={drop} isDropdownItem={true} onCopy={closeDropdown} />;
    $[24] = closeDropdown;
    $[25] = drop;
    $[26] = t14;
    $[27] = t15;
  } else {
    t14 = $[26];
    t15 = $[27];
  }
  let t16;
  if ($[28] !== closeDropdown || $[29] !== showCurationsAction) {
    t16 = showCurationsAction && <button type="button" onClick={event => {
      event.stopPropagation();
      closeDropdown();
      setIsCurationsDialogOpen(true);
    }} className="tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-gap-x-3 tw-rounded-lg tw-border-0 tw-bg-transparent tw-px-3 tw-py-2 tw-text-iron-300 tw-transition-colors tw-duration-200 desktop-hover:hover:tw-bg-iron-800"><WaveDropCurationsActionIcon className="tw-size-4 tw-flex-shrink-0" /><span className="tw-text-sm tw-font-medium">Curate</span></button>;
    $[28] = closeDropdown;
    $[29] = showCurationsAction;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  let t18;
  if ($[31] !== closeDropdown || $[32] !== drop) {
    t17 = <WaveDropActionsRestoreLinkPreviews drop={drop} onRestored={closeDropdown} />;
    t18 = <WaveDropActionsOpen drop={drop} isDropdownItem={true} onOpen={closeDropdown} />;
    $[31] = closeDropdown;
    $[32] = drop;
    $[33] = t17;
    $[34] = t18;
  } else {
    t17 = $[33];
    t18 = $[34];
  }
  let t19;
  if ($[35] !== canSetPinnedDrop || $[36] !== closeDropdown || $[37] !== drop) {
    t19 = canSetPinnedDrop && <WaveDropActionsSetPinnedDrop drop={drop} onPinnedDropSet={closeDropdown} />;
    $[35] = canSetPinnedDrop;
    $[36] = closeDropdown;
    $[37] = drop;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== canDelete || $[40] !== drop || $[41] !== handleDeleteClick) {
    t20 = canDelete && <WaveDropActionsOptions drop={drop} isDropdownItem={true} onDelete={handleDeleteClick} />;
    $[39] = canDelete;
    $[40] = drop;
    $[41] = handleDeleteClick;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t14 || $[44] !== t15 || $[45] !== t16 || $[46] !== t17 || $[47] !== t18 || $[48] !== t19 || $[49] !== t20) {
    t21 = <li className="tw-list-none"><div className="tw-flex tw-flex-col tw-gap-y-1 tw-py-1">{t14}{t15}{t16}{t17}{t18}{t19}{t20}</div></li>;
    $[43] = t14;
    $[44] = t15;
    $[45] = t16;
    $[46] = t17;
    $[47] = t18;
    $[48] = t19;
    $[49] = t20;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== handleOpenChange || $[52] !== isOpen || $[53] !== t21) {
    t22 = <CommonDropdownItemsDefaultWrapper isOpen={isOpen} setOpen={handleOpenChange} buttonRef={buttonRef}>{t21}</CommonDropdownItemsDefaultWrapper>;
    $[51] = handleOpenChange;
    $[52] = isOpen;
    $[53] = t21;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  let t23;
  if ($[55] !== drop || $[56] !== isDeleteModalOpen) {
    t23 = isDeleteModalOpen && <CommonAnimationOpacity key="modal" elementClasses="tw-absolute tw-z-50" elementRole="dialog" onClicked={_temp}><DropsListItemDeleteDropModal drop={drop} closeModal={() => setIsDeleteModalOpen(false)} /></CommonAnimationOpacity>;
    $[55] = drop;
    $[56] = isDeleteModalOpen;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  let t24;
  if ($[58] !== t23) {
    t24 = <CommonAnimationWrapper mode="sync" initial={true}>{t23}</CommonAnimationWrapper>;
    $[58] = t23;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  let t25;
  if ($[60] !== drop.id || $[61] !== drop.wave || $[62] !== isCurationsDialogOpen || $[63] !== showCurationsAction) {
    t25 = showCurationsAction && <WaveDropCurationsDialog dropId={drop.id} wave={drop.wave} isOpen={isCurationsDialogOpen} onClose={() => setIsCurationsDialogOpen(false)} />;
    $[60] = drop.id;
    $[61] = drop.wave;
    $[62] = isCurationsDialogOpen;
    $[63] = showCurationsAction;
    $[64] = t25;
  } else {
    t25 = $[64];
  }
  let t26;
  if ($[65] !== t12 || $[66] !== t13 || $[67] !== t22 || $[68] !== t24 || $[69] !== t25) {
    t26 = <>{t12}{t13}{t22}{t24}{t25}</>;
    $[65] = t12;
    $[66] = t13;
    $[67] = t22;
    $[68] = t24;
    $[69] = t25;
    $[70] = t26;
  } else {
    t26 = $[70];
  }
  return t26;
}
function _temp(e) {
  return e.stopPropagation();
}